import { render, staticRenderFns } from "./Test1List.vue?vue&type=template&id=4d2d0b75&"
import script from "./Test1List.vue?vue&type=script&lang=js&"
export * from "./Test1List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports